import { Navigate, Route, Routes } from "react-router-dom";

import { useWalletTopUpAccess } from "@/modules/dashboard/wallet-top-ups/hooks/useWalletTopUpAccess";
import { ColocaSkeleton } from "@/shared/components/feedback/ColocaSkeleton";

import WalletDebitsPage from "./pages/WalletDebitsPage";

// Debits share the top-ups allowlist. The registry's `enabled` flag only hides the menu entry, so the route
// closes itself too for staff off it; the backend refuses them regardless.
export const WalletDebitsNavigation = () => {
  const { allowed, isLoading } = useWalletTopUpAccess();
  if (isLoading) return <ColocaSkeleton className="m-2 h-40 w-full max-w-[1400px] rounded-2xl" />;
  if (!allowed) return <Navigate to="/app/wallets" replace />;
  return (
    <Routes>
      <Route index element={<WalletDebitsPage />} />
      <Route path="*" element={<Navigate to="/app/wallet-debits" replace />} />
    </Routes>
  );
};
